import React from 'react';
import { Link, LinkProps } from '@material-ui/core';

export const ExternalLink = ({ children, ...props }: LinkProps) => (
  <Link {...props} rel="noopener noreferrer">
    {children}
  </Link>
);
